module.exports = __webpack_public_path__ + "files/e4de5763f8725a1a7a925619a7463d28.ttf";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/Exo-2-regular.ttf
 ** module id = 851
 ** module chunks = 0
 **/